import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Labs: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M25.39 12h-1v10.081a3.86 3.86 0 01-.705 2.195s0 0 0 0L12.068 41.149h0c-1.52 2.21-1.324 4.733 0 6.657 1.31 1.903 3.69 3.194 6.527 3.194h22.81c2.838 0 5.217-1.291 6.527-3.194 1.324-1.924 1.52-4.447 0-6.657h0L36.315 24.276c-.469-.682-.706-1.439-.706-2.195V12H25.39z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Path
                d="M17.747 42.94l5.221-8.44h14.064l5.221 8.44c.675 1.091-.131 2.56-1.63 2.56H19.377c-1.5 0-2.306-1.469-1.631-2.56z"
                fill="#fff"
                stroke={props.color}
            />
            <Rect x={22} y={9} width={16} height={5} rx={2} fill="#fff" stroke={props.color} strokeWidth={2} />
        </Svg>
    );
};

export default React.memo(Labs);
